import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWho() {
  return <section className="bg-white py-20 px-6" data-id="element-141">
      <div className="max-w-5xl mx-auto" data-id="element-142">
        <FadeIn data-id="element-143">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-144">
            {/* For You */}
            <div data-id="element-145">
              <h3 className="font-serif text-2xl text-[#1B2A4A] mb-6 flex items-center gap-3" data-id="element-146">
                <span className="bg-[#3BBFAD]/20 text-[#3BBFAD] p-2 rounded-full" data-id="element-147">
                  <CheckIcon className="w-5 h-5" data-id="element-148" />
                </span>
                Es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-149">
                <li className="flex gap-3 text-[#1B2A4A]/80" data-id="element-150">
                  <CheckIcon className="w-5 h-5 text-[#3BBFAD] shrink-0 mt-0.5" data-id="element-151" />
                  <span data-id="element-152">Tienes un hijo/a de 18–24 meses.</span>
                </li>
                <li className="flex gap-3 text-[#1B2A4A]/80" data-id="element-153">
                  <CheckIcon className="w-5 h-5 text-[#3BBFAD] shrink-0 mt-0.5" data-id="element-154" />
                  <span data-id="element-155">
                    Hay dudas con gestos, atención conjunta, respuesta al
                    nombre, juego o comunicación.
                  </span>
                </li>
                <li className="flex gap-3 text-[#1B2A4A]/80" data-id="element-156">
                  <CheckIcon className="w-5 h-5 text-[#3BBFAD] shrink-0 mt-0.5" data-id="element-157" />
                  <span data-id="element-158">
                    Quieres actuar temprano sin caer en pánico ni convertirlo en
                    un “examen”.
                  </span>
                </li>
              </ul>
            </div>

            {/* Not For You */}
            <div className="bg-gray-50 p-8 rounded-2xl" data-id="element-159">
              <h3 className="font-serif text-2xl text-gray-500 mb-6 flex items-center gap-3" data-id="element-160">
                <span className="bg-gray-200 text-gray-500 p-2 rounded-full" data-id="element-161">
                  <XIcon className="w-5 h-5" data-id="element-162" />
                </span>
                No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-163">
                <li className="flex gap-3 text-gray-500" data-id="element-164">
                  <XIcon className="w-5 h-5 text-gray-400 shrink-0 mt-0.5" data-id="element-165" />
                  <span data-id="element-166">Buscas que una guía te diagnostique.</span>
                </li>
                <li className="flex gap-3 text-gray-500" data-id="element-167">
                  <XIcon className="w-5 h-5 text-gray-400 shrink-0 mt-0.5" data-id="element-168" />
                  <span data-id="element-169">Quieres promesas médicas.</span>
                </li>
                <li className="flex gap-3 text-gray-500" data-id="element-170">
                  <XIcon className="w-5 h-5 text-gray-400 shrink-0 mt-0.5" data-id="element-171" />
                  <span data-id="element-172">
                    No estás dispuesto/a a registrar 5 minutos al día por una
                    semana.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}